// CRS 確認モーダル（plan.md §5.5 / §10）。
//
// 役割: 取込ファイルの CRS がメタデータから判別できないとき、4326 と決め打ちせず
//       ユーザーに確認する。CRS が不明なまま距離・面積処理を走らせないための関門。
// 関係: App が UnknownCrsError を捕捉したときに開き、確定した CRS を onConfirm に返す。
//       App はその CRS を declaredCrs として取込パイプラインを再実行する。
import { useState } from 'react'

function CrsConfirmModal({ fileName, onConfirm, onCancel }) {
  // 既定は最も一般的な経緯度（EPSG:4326）。必要なら EPSG コードを手入力。
  const [mode, setMode] = useState('4326')
  const [epsg, setEpsg] = useState('')

  const confirm = () => {
    if (mode === '4326') {
      onConfirm('EPSG:4326')
    } else {
      const code = epsg.trim().replace(/^epsg:/i, '')
      if (!/^\d+$/.test(code)) return
      onConfirm(`EPSG:${code}`)
    }
  }

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal">
        <h3>取込データの座標系を確認</h3>
        <p>
          <code>{fileName}</code> の座標系（CRS）を自動判別できませんでした。
          正しい CRS を選んでください。誤った CRS のままでは距離・面積が破綻します。
        </p>

        <label className="radio-row">
          <input
            type="radio"
            name="crs-mode"
            checked={mode === '4326'}
            onChange={() => setMode('4326')}
          />
          経緯度（EPSG:4326）として扱う
        </label>

        <label className="radio-row">
          <input
            type="radio"
            name="crs-mode"
            checked={mode === 'epsg'}
            onChange={() => setMode('epsg')}
          />
          EPSG コードを指定:
          <input
            type="text"
            placeholder="例: 3857"
            value={epsg}
            onChange={(e) => setEpsg(e.target.value)}
            onFocus={() => setMode('epsg')}
            style={{ marginLeft: 6, width: 100 }}
          />
        </label>

        <div className="modal-actions">
          <button onClick={onCancel}>取込をやめる</button>
          <button className="primary" onClick={confirm}>
            この CRS で取り込む
          </button>
        </div>
      </div>
    </div>
  )
}

export default CrsConfirmModal
